import React, {useState} from 'react';
import {getRelativeTime} from 'app/components/tv/helpers/getRelativeTime';
import {checkForUnwatchedVideo} from 'app/components/tv/helpers/lastViewedVideos';
import {EmbeddedVideo} from 'app/components/tv/EmbeddedVideo';
import VideoPreview from 'app/components/tv/preview/VideoPreview';

export const EmbedTeaser = ({video}) => {
  const [open, setOpen] = useState(false);

  const unwatchedVideo = checkForUnwatchedVideo(video);

  return (
    <>
      <div onClick={() => setOpen(true)}>
        <VideoPreview
          thumbnail={video.thumbnail}
          updated={unwatchedVideo}
          source={video.data.source}
          title={video.data.source}
          caption={getRelativeTime(video.updatedAt)}
        />
      </div>
      <EmbeddedVideo open={open} onClose={() => setOpen(false)} entity={video.data} />
    </>
  );
};
